import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {WithStyles, withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import styles from './styles';
import {Avatar, Typography} from '@material-ui/core';
import {Profile} from 'feedback-system/dto/IProfile';
import {clearUser} from 'feedback-system/auth/actions';
import {redirectToLoginPage} from 'feedback-system/utils';

export interface OwnProps extends WithStyles<typeof styles> {
    user: Profile;
}

export interface State {
    anchorEl: HTMLElement | null;
}

interface Dispatch {
    clearUser: typeof clearUser;
}

type IProps = OwnProps & Dispatch;

class UserMenu extends Component<IProps, State> {
    state = {
        anchorEl: null
    };

    handleClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        this.setState({anchorEl: e.currentTarget});
    }

    handleClose = () => {
        this.setState({anchorEl: null});

    }

    logout = () => {
        if (localStorage.getItem('accessToken')) {
            this.props.clearUser();
            localStorage.removeItem('accessToken');
            redirectToLoginPage();
        }
    }

    render() {
        const {classes, user} = this.props;
        const {anchorEl} = this.state;

        return (
            <div>
                {user ?
                    <Button onClick={this.handleClick} className={classes.btn}>
                        <Typography
                            className={classes.userName}
                            variant="body1">
                            {user.firstName ? `${user.firstName} ${user.lastName}` : 'John Smith'}
                        </Typography>

                        {user.avatarUrl ?
                            <Avatar
                                alt={`${user.firstName} ${user.lastName}`}
                                src={user.avatarUrl}
                                className={classes.avatar}
                            /> :
                            <Avatar className={classes.avatar}>{user.firstName.charAt(0)}</Avatar>
                        }
                    </Button> : <Avatar className={classes.avatarPreloader}>&nbsp;</Avatar>
                }
                <Menu className={classes.menu}
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                    transformOrigin={{vertical: 'bottom', horizontal: 'right'}}
                    getContentAnchorEl={null}
                    onClose={this.handleClose}>
                    <MenuItem onClick={this.handleClose}>
                        <Link className={classes.link}
                            to="/profile">
                            Profile
                        </Link>
                    </MenuItem>
                    <MenuItem onClick={this.logout}>
                        Logout
                    </MenuItem>
                </Menu>
            </div>
        );
    }
}

interface StateProps {
    authenticated: Profile;
}

const mapStateToProps = (state: StateProps) => ({
    user: state.authenticated
});

const mapDispatchToProps: Dispatch = {clearUser};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default withStyles(styles)(connector(UserMenu));
